/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccommodationPoints } from '../models/AccommodationPoints';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccommodationPointsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves the collection of AccommodationPoints resources.
     * Retrieves the collection of AccommodationPoints resources.
     * @param ids
     * @param type
     * @param listingId
     * @returns AccommodationPoints AccommodationPoints collection
     * @throws ApiError
     */
    public getPoints(
        ids?: string,
        type?: string,
        listingId?: string,
    ): CancelablePromise<Array<AccommodationPoints>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/score/points',
            query: {
                ids: ids,
                type: type,
                listingId: listingId,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
